import { computed, Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ProgressBarService {
  private readonly manualProgressBar = signal(false);
  private readonly showFullscreenSpinner = signal(false);
  private readonly _inFlight = signal(0);

  readonly inFlight = this._inFlight.asReadonly();

  private readonly visible = computed(() => this.manualProgressBar() || this._inFlight() > 0);

  get progressBar() {
    return this.visible;
  }

  get fullscreenSpinner() {
    return this.showFullscreenSpinner;
  }

  requestStarted() {
    this._inFlight.update(count => count + 1);
  }

  requestFinished() {
    this._inFlight.update(count => (count > 0 ? count - 1 : 0));
  }

  show() {
    this.manualProgressBar.set(true);
  }

  hide() {
    this.manualProgressBar.set(false);
  }

  showFullscreen() {
    this.showFullscreenSpinner.set(true);
  }

  hideFullscreen() {
    this.showFullscreenSpinner.set(false);
  }
}